import { SnotifyStyles } from '../interfaces/SnotifyStyles.interface';
/**
 * Toast style.
 */
export const SnotifyStyle: SnotifyStyles = {
  simple: 'simple',
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
  async: 'async',
  confirm: 'confirm',
  prompt: 'prompt',
};
